document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-samples-product]')?.closest('form');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');
  const colour = params.get('kleur');
  const productSelect = form.querySelector('[data-samples-product]');
  const colourInput = form.querySelector('[data-samples-colour]');

  if (product && productSelect) {
    const match = [...productSelect.options].find((option) => option.dataset.productHandle === product);
    if (match) productSelect.value = match.value;
  }
  if (colour && colourInput) colourInput.value = colour;

  if (product || colour) {
    const heading = document.querySelector('#stalen-aanvragen h2');
    if (heading) heading.textContent = 'Je stofstalenaanvraag staat klaar';
  }
});
